import Fragment from "./direct_light_ao.glsl";

export default shader => {
  shader.fragmentShader = shader.fragmentShader.replace("#include <aomap_fragment>", Fragment);
};
